var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-alert',{staticStyle:{"margin-bottom":"10px"},attrs:{"title":"这里能查询到资产领用交还记录中全部明细记录","type":"success"}}),_c('use-return-list',{ref:"list",attrs:{"show-query-more":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }